import { UserManagementCreation } from '@/features/user-management/user-management-creation';

const UserManagementCreationPage = () => {
  return <UserManagementCreation />;
};

export default UserManagementCreationPage;
